import { createFileRoute } from "@tanstack/react-router";

import { Grants } from "@/features/admin";

export const Route = createFileRoute("/admin/grants")({
  component: Grants,
});
